var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketballDeflection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 900",
    width: 1600,
    height: 900,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "#111"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4AF626",
    strokeOpacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 150H1600M0 300H1600M0 450H1600M0 600H1600M0 750H1600M200 0V900M400 0V900M600 0V900M800 0V900M1000 0V900M1200 0V900M1400 0V900"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Consolas, 'Courier New', monospace",
    fill: "#4AF626"
  }, /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 360,
    fontSize: 110,
    fontWeight: "bold"
  }, "Basketball Deflection"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 500,
    fontSize: 110,
    fontWeight: "bold"
  }, "Detection"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 640,
    fontSize: 56,
    fillOpacity: 0.75
  }, "> YOLOv8 + SigLIP + BiLSTM", /*#__PURE__*/React.createElement("tspan", {
    fillOpacity: 1
  }, "_")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketballDeflection);
export default __webpack_public_path__ + "static/media/basketball-deflection.71f3790d70f03273a2eb86e5d710cf64.svg";
export { ForwardRef as ReactComponent };